import styles from './PrintFlyer.styles';
import React from 'react';
import { Page } from '@/graphql/types';

interface Props {
    pages: Page[];
}

export const PrintFlyer: React.FC<Props> = ({ pages }) => (
  <div className={styles.container}>
    <div className="printable">
      {pages.map((page) => (
        <img
          key={`page_${page.pageNumber}`}
          src={page.imageUrl}
          alt={`Page ${page.pageNumber}`}
        />
      ))}
    </div>
  </div>
);
